import React from "react";
import { motion } from "framer-motion";
import pinterestLogo from "../../pinterest.png";
import instagramLogo from "../../instagram.png";
import Logo from "../../LOGO.svg";

const Footer = () => {
  const socialLinks = [
    "https://www.instagram.com/olivieri.rosalba1?igsh=MWJ5N2thY3Z6dmMwMw%3D%3D&utm_source=qr",
    "https://pin.it/7Jaj5UR2C",
  ];
  const footerLinks = [
    "Términos de servicio",
    "Política de privacidad",
    "Cookies",
    "Accesibilidad",
  ];

  return (
    <footer className="bg-primary-darker py-12 border-t border-accent border-opacity-20">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8">
          <div className="mb-6 md:mb-0">
            <div>
              <img
                src={Logo}
                alt="Arte Olivieri Logo"
                className="h-8 w-auto ml-5 mr-5"
              />
            </div>
            <h2 className="text-2xl font-bold text-accent-light">
              ARTE OLIVIERI
            </h2>
            <p className="text-accent-light text-opacity-70 mt-2">
              Arte que trasciende lo ordinario
            </p>
          </div>

          <div className="flex gap-6">
            {socialLinks.map((social, idx) => {
              const isUrl =
                typeof social === "string" && social.startsWith("http");
              const href = isUrl ? social : `#${social}`;
              const isInstagram = isUrl && social.includes("instagram.com");
              const isPinterest =
                (isUrl && social.includes("pin.it")) ||
                social.includes("pinterest.com");

              return (
                <motion.a
                  key={idx}
                  href={href}
                  aria-label={
                    isInstagram
                      ? "Instagram"
                      : isPinterest
                      ? "Pinterest"
                      : social
                  }
                  target={isUrl ? "_blank" : undefined}
                  rel={isUrl ? "noopener noreferrer" : undefined}
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  className="w-10 h-10 rounded-full bg-accent flex items-center justify-center text-primary-dark transition-colors duration-300 hover:bg-accent-light"
                >
                  {isInstagram ? (
                    // Instagram logo - image
                    <img
                      src={instagramLogo}
                      alt="Instagram"
                      className="w-5 h-5"
                    />
                  ) : isPinterest ? (
                    // Pinterest logo - image
                    <img
                      src={pinterestLogo}
                      alt="Pinterest"
                      className="w-5 h-5"
                    />
                  ) : (
                    // fallback circle icon for other socials
                    <svg
                      className="w-5 h-5"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 2C6.477 2 2 6.477 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10C22 6.477 17.523 2 12 2z"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </motion.a>
              );
            })}
          </div>
        </div>

        <div className="border-t border-accent border-opacity-20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-accent-light text-opacity-60 text-sm mb-4 md:mb-0">
              &copy; {new Date().getFullYear()} ARTE OLIVIERI. Todos los
              derechos reservados.
            </p>

            <div className="flex flex-wrap gap-6 justify-center">
              {footerLinks.map((link, idx) => (
                <a
                  key={idx}
                  href="#"
                  className="text-sm text-accent-light text-opacity-60 hover:text-accent transition-colors duration-300"
                >
                  {link}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
